<div class="border-top pt-4">
  <div class="col-12 p-5">
    <div class="row justify-content-around align-items-center">
      <div class="col-5"
        (click)="titledModal.open({title: eventTerms.deliveryTermsPopUpTitle, content: eventTerms.deliveryTerms, closeButtonName:eventTerms.OkPopUpMessage})">
        {{ 'Buyer.DeliveryTerms' | translate }}
      </div>
      <div class="col-5"
        (click)="titledModal.open({title: eventTerms.returnTermsPopUpTilte, content: eventTerms.returnTerms, closeButtonName: eventTerms.OkPopUpMessage})">
        {{ 'Buyer.ReturnTerms' | translate }}
      </div>
      <div class="col-2 text-end">[+]</div>
    </div>
  </div>
</div>
